<ion-header class="modal-header">
  <div class="modal-title">
    <h3>{{ id ? 'Edit Escalation Path' : 'Add Escalation Path' }}</h3>
  </div>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="clear" shape="round" class="close-button" (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div style="padding: 16px">
    <ion-label class="input-label"> Name </ion-label>
    <ion-input #nameInput placeholder="e.g. Engineering Escalation" [(ngModel)]="name" class="input-field"> </ion-input>

    <ion-label class="input-label"> Description </ion-label>
    <ion-textarea
      placeholder="Describe this escalation type..."
      [(ngModel)]="description"
      class="input-field"
      rows="3"
      [autoGrow]="true"
    ></ion-textarea>

    <ion-label class="input-label"> Workflow </ion-label>
    <div style="display: flex; flex-direction: column; align-items: center">
      <ion-badge color="dark"> Initiate escalation </ion-badge>
      <ion-icon name="arrow-down" class="support-step-icon"></ion-icon>
      <ion-badge color="dark"> Show popup modal </ion-badge>
      <ion-card class="outline-card no-margin" style="padding: 8px 4px">
        <ion-list class="no-padding">
          <ion-item class="ion-item-rounded">
            <ion-label>
              <ion-icon name="star-outline" class="padded-icon button-icon"></ion-icon>
              Choose priority?
            </ion-label>
            <ion-select
              [(ngModel)]="prioritySelector"
              interface="popover"
              placeholder="Priority selector"
              class="select-outline"
              slot="end"
            >
              <ion-select-option [value]="0"> Not shown </ion-select-option>
              <ion-select-option [value]="1"> Optional </ion-select-option>
              <ion-select-option [value]="2"> Required </ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item class="ion-item-rounded">
            <ion-label>
              <ion-icon name="person-outline" class="padded-icon button-icon"></ion-icon>
              Choose assignee?
            </ion-label>
            <ion-select
              [(ngModel)]="assigneeSelector"
              interface="popover"
              placeholder="Assignee selector"
              class="select-outline"
              slot="end"
            >
              <ion-select-option [value]="0"> Not shown </ion-select-option>
              <ion-select-option [value]="1"> Optional </ion-select-option>
              <ion-select-option [value]="2"> Required </ion-select-option>
            </ion-select>
          </ion-item>
        </ion-list>

        <div *ngIf="assigneeSelector !== 0" style="padding: 0 12px">
          <ion-label class="input-label"> Allowed Assignees </ion-label>
          <div style="padding: 10px 0">
            <ion-chip
              *ngFor="let entity of assigneeEntities; trackBy: trackByAssigneeEntityId"
              mode="ios"
              color="dark"
              class="chip clickable-chip"
              style="margin: 0 3px"
              (click)="removeAssigneeEntity(entity)"
            >
              <ion-label>
                {{ entity.name }}
              </ion-label>
            </ion-chip>
            <ion-chip
              mode="ios"
              color="dark"
              class="chip clickable-chip"
              (click)="addAssigneeEntity()"
              ngxTippy
              [tippyProps]="{
                touch: false,
                arrow: false,
                placement: 'bottom',
                content: 'Add assignee'
              }"
            >
              <ion-label>
                <ion-icon name="person-outline"></ion-icon
                ><ion-icon name="add-outline" style="margin-left: -3px"></ion-icon>
              </ion-label>
            </ion-chip>
          </div>
        </div>
      </ion-card>
      <ion-icon name="arrow-down" class="support-step-icon"></ion-icon>
      <ion-badge color="dark"> Post thread to Slack channel </ion-badge>
      <ion-card class="outline-card no-margin">
        <ion-card-content>
          <app-channel-selector
            [channel]="slackChannel"
            (channelDidChange)="onSlackChannelChanged($event)"
            [initialButtonText]="'Select channel'"
            [hideUnlinkButton]="true"
            [hideLinkedToText]="true"
          ></app-channel-selector>
        </ion-card-content>
      </ion-card>
    </div>
  </div>
</ion-content>

<ion-footer class="footer flex-space-between">
  <ion-button (click)="submit()" [disabled]="isLoading">
    Save
    <ion-spinner name="crescent" [hidden]="!isLoading" style="margin-left: 10px"></ion-spinner>
  </ion-button>
  <div>
    <ion-button
      fill="clear"
      color="dark"
      (click)="delete()"
      [disabled]="isLoading"
      *ngIf="id"
      ngxTippy
      data-tippy-content="Delete"
    >
      <ion-icon name="trash-outline"></ion-icon>
    </ion-button>
  </div>
</ion-footer>
